import React from "react";
import SubscriptionBanners from "./subscription-banners";

export default function ContentWrapper(props) {
    return (
        <div className="relative flex flex-col break-words min-w-screen">
            {!props?.hideBanners && <SubscriptionBanners />}
            <div className="p-0 m-0">{props.children}</div>
        </div>
    );
}
